import { icons } from '@ublend-npm/aulaui-next';
import React from 'react';
import { ReactEditor } from 'slate-react';
import { NestedMenuItem } from '../../components/NestedMenu/NestedMenu';
import { AulaPlugin } from '../plugins';
import { useAnalytics } from '../../lib/useAnalytics';

export const templates: AulaPlugin = (editableProps, editor, context) =>
  context?.templates?.length
    ? {
        ...editableProps,
        blockMenu: {
          ...editableProps.blockMenu,
          Templates: ({ text, element, attributes, onClose }: any) => {
            const track = useAnalytics();
            return (
              <NestedMenuItem
                leftIcon={<icons.Templates />}
                key={text}
                text={text}
                attributes={{
                  ...attributes,
                  onClick: () => {
                    const path = ReactEditor.findPath(editor, element);
                    track('OPEN_EDITOR_TEMPLATES');
                    context?.setTemplatesPath(path);
                    onClose?.();
                  },
                }}
              />
            );
          },
        },
      }
    : editableProps;
